import styled, { css } from 'styled-components';

const Switcher = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50%;
  background: ${({ theme }) => theme.colors.deep_purple};
  overflow: hidden;
  border-radius: 25px;
  transition: left 0.5s ease;
  ${({ active }) =>
    active &&
    css`
      left: 50%;
    `}
`;

export default Switcher;
